var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObservedReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,1H9A3,3,0,0,0,6,4V6H4A3,3,0,0,0,1,9V22a3,3,0,0,0,3,3H5v3.54a2.46,2.46,0,0,0,4.06,1.87L15.37,25H23a3,3,0,0,0,3-3V20h2a3,3,0,0,0,3-3V4A3,3,0,0,0,28,1ZM24,22a1,1,0,0,1-1,1H10v2h2.3L7.76,28.89A.48.48,0,0,1,7,28.54V24a1,1,0,0,0-1-1H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8H23a1,1,0,0,1,1,1Zm5-5a1,1,0,0,1-1,1H26V9a3,3,0,0,0-3-3H8V4A1,1,0,0,1,9,3H28a1,1,0,0,1,1,1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18.5,
    width: 14,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 9,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 10.5,
    width: 3,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 14.5,
    width: 14,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservedReply);
export default __webpack_public_path__ + "static/media/observedReply.641596023fcea97e2ae3b9d8fdb29eac.svg";
export { ForwardRef as ReactComponent };